import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    Breadcrumbs,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    IconButton,
    MenuItem,
    Select,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Config from "Config";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { Constant } from "../../Constant";
import CustomYupTest from "../../CustomYup/CustomYupTest";
import { extractCookie } from "../../SendRequest";
import {
    checkReviewer,
    getUserAgent,
    isEmpty,
    isNotEmpty,
    isObjectNotEmpty,
    parseIntFormRef,
} from "../../Utils";
import Mode from "../../constant/Mode";
import govLogoEn from "../../images/logo_en.svg";
import govLogoCn from "../../images/logo_sc.svg";
import govLogoZh from "../../images/logo_tc.svg";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import {
    resetApplicantFormList,
    resetProfile,
    resetToken,
    setCurrUserOrg,
    setSelectedSCRN,
    updateMobileNavStatus,
    updateProfile,
    updateSelectedSCRN,
} from "../../redux/action";
import {
    getCLO,
    getCurrentWorkFlow,
    getForm,
    getFormId,
    getIsLoginDialogOpen,
    getMobileNavStatus,
    getMode,
    getProfile,
    getSelectedUserOrg,
    getStatus,
    getToken,
    getUserOrg,
    getUserRole,
    getUserSCRN,
} from "../../redux/selector";
import AlertDialog from "../AlertDialog/AlertDialog";
import PortalNavbar from "../PortalNavbar/PortalNavbar";
// import transportIco from '../../images/transport.svg'
import { useAuth } from "../../component/AuthContext/AuthContext";
import "./Header.scss";
import Notifaction from "./Notification";
import SearchTemplate from "./SearchTemplate";

export default function Header({
    onLangChange,
    displayLang = true,
    disableEN = false,
    disableSC = false,
    disableTC = false,
    formName,
    headerTitle,
    edb = false,
    cangreyScreen = false,
}) {
    const [openPopup, setOpenPopup] = useState(false);
    const [popupLang, setPopupLang] = useState("en");
    const [loadedTemp, setLoadedTemp] = useState(false);
    const handleClose = () => setOpenPopup(false);
    const { emailTest } = CustomYupTest();
    const [open, setOpen] = useState(false);
    // const [updateEmail, setUpdateEmail] = useState();
    const [errorOpen, setErrorOpen] = useState(false);
    const { setIsChangingPassword } = useAuth();
    const { t, i18n } = useTranslation();
    const isMobile = isNotEmpty(getUserAgent()) && getUserAgent() !== "Firefox";
    const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
    const grayClass = cangreyScreen ? "greyScreen" : "";
    let navigate = useNavigate();

    useEffect(() => {
        switch (i18n.language) {
            case "en":
                if (disableEN) {
                    if (disableTC) {
                        i18n.changeLanguage("sc");
                    } else {
                        i18n.changeLanguage("tc");
                    }
                }
                break;
            case "tc":
                if (disableTC) {
                    if (disableSC) {
                        i18n.changeLanguage("en");
                    } else {
                        i18n.changeLanguage("sc");
                    }
                }
                break;
            case "sc":
                if (disableSC) {
                    if (disableTC) {
                        i18n.changeLanguage("en");
                    } else {
                        i18n.changeLanguage("tc");
                    }
                }
                break;
            default:
                //no language or not supported language
                i18n.changeLanguage("en");
                break;
        }
    }, [i18n.language]);

    const query = new URLSearchParams(useLocation().search);
    const lang = query.get("lang");

    useEffect(() => {
        switch (lang) {
            case "tc":
            case "sc":
            case "en":
                changeLanguage(lang);
                break;
            default:
                break;
        }
    }, [lang]);

    const isMobileNavOpen = useSelector(getMobileNavStatus());
    const dispatch = useDispatch();
    const location = useLocation();
    const token = useSelector(getToken());
    const { name, post, interfaceUsername } = useSelector(getProfile());
    const userOrg = useSelector(getUserOrg());
    const selectedUserOrg = useSelector(getSelectedUserOrg());
    const formId = useSelector(getFormId());
    const isInFormProcess = isNotEmpty(formId);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const mode = useSelector(getMode());
    const isEdbEditing = mode === Mode.edbEditing;
    const isEditing = mode === Mode.editing || isEdbEditing;
    const currentWorkFlow = useSelector(getCurrentWorkFlow());
    const profile = useSelector(getProfile());
    const clo = useSelector(getCLO());
    const isReviewer = checkReviewer(currentWorkFlow, profile);
    const role = useSelector(getUserRole());
    const isLoginDialogOpen = useSelector(getIsLoginDialogOpen());

    const changeLanguage = (lang) => {
        if (isInFormProcess) {
            setPopupLang(lang);
            setOpenPopup(true);
        } else {
            if (lang === "tc") {
                i18n.changeLanguage("tc");
                !!onLangChange && onLangChange("tc");
            } else if (lang === "sc") {
                i18n.changeLanguage("sc");
                !!onLangChange && onLangChange("sc");
            } else {
                i18n.changeLanguage("en");
                !!onLangChange && onLangChange("en");
            }
        }
    };
    const handleConfirm = () => {
        setOpenPopup(false);
        i18n.changeLanguage(popupLang);

        // Sync URL parameters for Form105 with language parameter
        if (formId === "Form105") {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set("language", popupLang);
            window.history.replaceState(
                null,
                "",
                `${window.location.pathname}?${urlParams.toString()}`
            );
        }

        window.location.reload();
    };

    const handleLogout = () => {
        if (
            navigator.userAgent.includes("iAM Smart In-App Browser") &&
            window.eIDJSBridge
        ) {
            // Clean up all authentication data before closing In-App Browser
            window.eIDJSBridge.closeInAppBrowser();
        } else {
            removeCookie("token", {
                path: `${Config.CONTENT_PATH}`,
            });
            dispatch(resetToken());
            dispatch(resetProfile());
            dispatch(resetApplicantFormList());
            var self = window.self;
            self.opener = window.self;
            self.close();
            if (selectedUserOrg?.organization === Constant.EDBName || edb) {
                navigate("/edbuserlogin");
            } else {
                navigate("/Login");
            }
            setIsChangingPassword(false);
        }
    };

    let pathList = [
        isEmpty(token) ? "/Login" : "/main",
        isReviewer || role == "E" || role == "FO" || role == "FR"
            ? "/FormEnquiry"
            : "/select",
        `${location.pathname}`,
    ];
    const pathTranslation = ["Home", "eFormSS", `${location.pathname}`];
    const directList = [
        "/login",
        "/Login",
        "/edbuserlogin",
        "/Edbuserlogin",
        "/GuidanceNotes",
        "/OnlineTutorial",
        "/Faq",
        "/Enquiry",
        "/MaintenanceTime",
        "/loginSSLO",
        "/loginPublic",
    ];
    const resultedList = [];
    if (directList.includes(location.pathname)) {
        resultedList.push(pathTranslation[0]);
        resultedList.push(location.pathname);
        pathList = [];
        pathList.push("/main");
        pathList.push(location.pathname);
    } else if (location.pathname.startsWith("/main/")) {
        resultedList.push(pathTranslation[0]);
        pathList = [];
        pathList.push("/main");
    } else {
        for (let i = 0; i <= pathList.indexOf(location.pathname); i++) {
            if (
                pathList.indexOf(location.pathname) == i &&
                location.pathname.startsWith("/Form")
            ) {
                resultedList.push("");
            } else if (
                pathList.indexOf(location.pathname) == i &&
                location.pathname.startsWith("/approval")
            ) {
                resultedList.push("Approval");
            } else if (
                pathList.indexOf(location.pathname) == i &&
                location.pathname.startsWith("/select")
            ) {
                resultedList.push("eFormSS");
            } else if (
                pathList.indexOf(location.pathname) == i &&
                location.pathname.startsWith("/draft")
            ) {
                resultedList.push("FormDraft");
            } else {
                resultedList.push(pathTranslation[i]);
            }
        }
    }

    const govLogo =
        /*matches
        ?*/ i18n.language === "tc"
            ? govLogoZh
            : i18n.language === "sc"
            ? govLogoCn
            : govLogoEn;
    /*: i18n.language === "tc" || i18n.language === "sc"
        ? govLogoMobileCn
        : govLogoMobileEn;*/

    const handleUserOrgChange = (event) => {
        dispatch(setCurrUserOrg(event.target.value));
        dispatch(setSelectedSCRN(event.target.value.scrn));
        dispatch(updateSelectedSCRN(event.target.value.scrn));
    };

    const scrn = useSelector(getUserSCRN());
    const formStatus = useSelector(getStatus());
    const { referenceId, currentStep, initialStep } = useSelector(getForm());
    const formRef = parseIntFormRef(referenceId);
    /* useEffect(() => {
        if (
            formStatus == -1 && // change "mode = formfilling" to "formStatus = -1", to avoid applicant resubmission load form
            isNotEmpty(formId) &&
            isNotEmpty(formName) &&
            isNotEmpty(cookies?.token) &&
            isNotEmpty(role) &&
            (isCLO(role) ? isNotEmpty(scrn) : true)
        ) {
            dispatch(getParameterRequest(formId)).then((latestParameter) => {
                if (
                    !loadedTemp &&
                    getIsWithinDeadlineFormTemp(formName, latestParameter)
                ) {
                    dispatch(getFormTempRequest(formName, scrn, i18n));
                    setLoadedTemp(true);
                }
            });
        }
    }, [token, scrn, mode, formId, formName, role]); */

    useEffect(() => {
        if (
            (profile.email == "" || profile.email == null) &&
            clo.type === "D" &&
            profile.interfaceUsername !== ""
        ) {
            setOpen(true);
            //setOpen(false); //暫時disable
        } else {
            setOpen(false);
        }
    }, [profile]);

    let yupSchema = yup.object().shape({
        email: yup
            .string()
            .required(t("errorMsg.email.message"))
            .test(...emailTest)
            .max(255, t("errorMsg.maxTextLength", { max: 255 })),
        confirmEmain: yup
            .string()
            .required(t("errorMsg.email.rule"))
            .test(
                "same to email",
                t("common.portal.errorConfirmEmain"),
                (val, data) => {
                    let enterEmail = data.parent.email;
                    if (isNotEmpty(val) && isNotEmpty(enterEmail)) {
                        return val == enterEmail;
                    } else {
                        return false;
                    }
                }
            ),
    });

    const { register, handleSubmit, control, formState, reset, watch } =
        useForm({
            mode: "onBlur",
            resolver: yupResolver(yupSchema),
        });
    const errors = formState.errors;

    // const handlePopUpClose = () => {
    //     if (errors.email == null && updateEmail != null) {
    //         setOpen(false);
    //     }
    // };

    const preventCopyPaste = (e) => {
        e.preventDefault();
    };

    const onSubmit = (data) => {
        // console.log("send data: ", data);
        var token = extractCookie("token");
        var requestHeader = {
            "Content-Type": "application/json",
            Accept: "application/json",
        };
        if (isObjectNotEmpty(token)) {
            requestHeader["Authorization"] = `Bearer ${token}`;
        }
        let email = data.email;
        const option = `${Config.CONTENT_PATH}/users/updateUserEmail/${email}`;
        fetch(option, {
            method: "PUT",
            headers: requestHeader,
        })
            .then((response) => response.json())
            .then((data) => {
                setOpen(false);
                dispatch(updateProfile(scrn));
            })
            .catch((error) => {
                setErrorOpen(true);
            });
    };

    return (
        <Box className="header">
            <Box id="skip-link" className={grayClass}>
                <a id="top" className="element-invisible"></a>
                <a
                    href="#main-content"
                    className="element-invisible element-focusable"
                    tabIndex="0"
                >
                    {t("common.tabAccessSkip")}
                </a>
            </Box>
            <div className={grayClass}>
                <Dialog open={open} aria-labelledby="form-dialog-title">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <DialogTitle id="form-dialog-title">
                            {t(`common.popUpBox.updateProfile`)}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {t(`common.popUpBox.provideEmail`)}
                            </DialogContentText>
                            <CustomTextField
                                label={t("common.portal.username")}
                                inputProps={{
                                    ...register("email"),
                                }}
                                onCopy={(e) => preventCopyPaste(e)}
                                onPaste={(e) => preventCopyPaste(e)}
                                onCut={(e) => preventCopyPaste(e)}
                                // onChange={(data) => setUpdateEmail(data)}
                                style={{ width: "450px" }}
                                error={errors?.email}
                            />
                            <CustomTextField
                                label={t("common.portal.confirmEmain")}
                                inputProps={{
                                    ...register("confirmEmain"),
                                }}
                                onCopy={(e) => preventCopyPaste(e)}
                                onPaste={(e) => preventCopyPaste(e)}
                                onCut={(e) => preventCopyPaste(e)}
                                style={{ width: "450px", marginTop: "16px" }}
                                error={errors?.confirmEmain}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                type="submit"
                                // onClick={handlePopUpClose}
                                color="primary"
                            >
                                {t("common.popUpBox.submit")}
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </div>
            {isMobile ? (
                <></>
            ) : (
                <Box className="headerTop">
                    <Link className="logo" to="/main">
                        {/*<img
                            style={
                                matches
                                    ? { height: "70px" }
                                    : { height: "50px" }
                            }
                            src={govLogo}
                            alt={t("common.portal.govLogoAlt")}
                        />*/}
                        <img
                            style={{
                                maxHeight: "70px",
                                maxWidth: "500px",
                                //width: "100%",
                            }}
                            src={govLogo}
                            alt={t("common.portal.govLogoAlt")}
                        />
                    </Link>
                    <Box className={grayClass}>
                        <Box className="rightTool">
                            {displayLang && (
                                <Box>
                                    {i18n.language !== "en" && !disableEN && (
                                        <span
                                            className="langSwitch"
                                            id="langSwitch_en"
                                            onClick={() => changeLanguage("en")}
                                            tabIndex="0"
                                        >
                                            {t("common.en")}
                                        </span>
                                    )}
                                    {i18n.language !== "tc" && !disableTC && (
                                        <span
                                            className="langSwitch"
                                            id="langSwitch_tc"
                                            onClick={() => changeLanguage("tc")}
                                            tabIndex="0"
                                        >
                                            {t("common.tc")}
                                        </span>
                                    )}
                                    {i18n.language !== "sc" && !disableSC && (
                                        <span
                                            className="langSwitch"
                                            id="langSwitch_sc"
                                            onClick={() => changeLanguage("sc")}
                                            tabIndex="0"
                                        >
                                            {t("common.sc")}
                                        </span>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box>
            )}
            {isMobile && (
                <>
                    <Box className="headerTop">
                        <Link className="logo" to="/main">
                            {/*<img
                            style={
                                matches
                                    ? { height: "70px" }
                                    : { height: "45px" }
                            }
                            src={govLogo}
                            alt={t("common.portal.govLogoAlt")}
                        />*/}
                            <img
                                style={{
                                    maxHeight: "70px",
                                    maxWidth: "370px",
                                    //width: "100%",
                                }}
                                src={govLogo}
                                alt={t("common.portal.govLogoAlt")}
                            />
                        </Link>
                    </Box>
                    <Box className={grayClass}>
                        <Box
                            className="rightTool"
                            style={{ marginBottom: "0.5rem" }}
                        >
                            {displayLang && (
                                <Box>
                                    {i18n.language !== "en" && !disableEN && (
                                        <span
                                            className="langSwitch"
                                            id="langSwitch_en"
                                            onClick={() => changeLanguage("en")}
                                            tabIndex="0"
                                        >
                                            {t("common.en")}
                                        </span>
                                    )}
                                    {i18n.language !== "tc" && !disableTC && (
                                        <span
                                            className="langSwitch"
                                            id="langSwitch_tc"
                                            onClick={() => changeLanguage("tc")}
                                            tabIndex="0"
                                        >
                                            {t("common.tc")}
                                        </span>
                                    )}
                                    {i18n.language !== "sc" && !disableSC && (
                                        <span
                                            className="langSwitch"
                                            id="langSwitch_sc"
                                            onClick={() => changeLanguage("sc")}
                                            tabIndex="0"
                                        >
                                            {t("common.sc")}
                                        </span>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                </>
            )}
            {!isLoginDialogOpen && (
                <Notifaction fixed edb={edb} closedButton />
            )}
            <Box className={grayClass}>
                <Box className="searchBox">
                    <Box>
                        {isMobile ? (
                            <Typography
                                style={{
                                    fontSize: "1.3rem",
                                    textAlign: "center",
                                }}
                            >
                                {t("common.sysTitle")}
                            </Typography>
                        ) : (
                            <Typography style={{ fontSize: "1.3rem" }}>
                                {t("common.sysTitle")}
                            </Typography>
                        )}
                    </Box>
                    <SearchTemplate />
                </Box>
            </Box>
            {/* web */}
            <Box
                style={{ width: "100%", clear: "both" }}
                className={`${grayClass} ${isMobile ? "" : "breadcrumbsBox"}`}
                sx={{ display: { xs: "none", sm: "none" } }}
            >
                <Box
                    sx={{ display: { xs: "none", sm: "block" } }}
                    style={{ flexShrink: "0" }}
                >
                    <Breadcrumbs
                        aria-label="breadcrumbs"
                        separator={<NavigateNextIcon fontSize="small" />}
                        style={{ display: "inline-block" }}
                    >
                        {resultedList.map((item, index) => {
                            if (item !== "")
                                return (
                                    <Link
                                        color="inherit"
                                        to={pathList[index]}
                                        key={item}
                                    >
                                        {item == "Approval" &&
                                        index == resultedList.length - 1
                                            ? t("common.approval.title")
                                            : item === ""
                                            ? ""
                                            : item.replace("/", "") === "Login"
                                            ? t("common.portal.login")
                                            : item.replace("/", "") ===
                                              "loginPublic"
                                            ? t("common.portal.publicLogin")
                                            : t(
                                                  `common.portal.${item.replace(
                                                      "/",
                                                      ""
                                                  )}`
                                              )}
                                    </Link>
                                );
                        })}
                    </Breadcrumbs>
                </Box>

                <Box sx={{ width: { xs: "100%", sm: "60%" } }}>
                    <Box className="userOrgBox" style={{ width: "100%" }}>
                        {isNotEmpty(name) && (
                            <Box
                                id="profile"
                                // sx={{
                                //     display: {
                                //         xs: "none",
                                //         sm: "none",
                                //         smd: "block",
                                //         md: "block",
                                //     },
                                // }}
                            >
                                {selectedUserOrg?.type !== "E" && name}
                                {/* #344 Split the accounts clo / sslo / public and reviewer accounts Begin */}
                                {selectedUserOrg?.type !== "E" &&
                                    selectedUserOrg?.type !== "P" &&
                                    selectedUserOrg?.type !== "S" &&
                                    " " +
                                        t(`common.bracketLeft`) +
                                        interfaceUsername +
                                        t(`common.bracketRight`)}
                                {/* #344 Split the accounts clo / sslo / public and reviewer accounts End */}
                                {isNotEmpty(post) &&
                                    (selectedUserOrg?.type === "E"
                                        ? `${post}`
                                        : `（${post}）`)}
                            </Box>
                        )}
                        {userOrg.length > 0 &&
                            isObjectNotEmpty(selectedUserOrg) && (
                                <Box id="userOrg">
                                    <FormControl id="userOrg-label">
                                        <Select
                                            labelId="userOrg-label"
                                            id="userOrg-select"
                                            value={selectedUserOrg}
                                            label={t("common.schoolName")}
                                            onChange={handleUserOrgChange}
                                            inputProps={{
                                                "aria-labelledby":
                                                    "userOrg-select",
                                            }}
                                        >
                                            {userOrg.length > 0 &&
                                                userOrg.map((item) => (
                                                    <MenuItem
                                                        value={item}
                                                        key={item.fullName}
                                                    >
                                                        {item.fullName}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            )}

                        <Box id="logoutBtn" onClick={handleLogout}>
                            {t(
                                `common.portal.${
                                    isEmpty(token) ? "login" : "logout"
                                }`
                            )}
                        </Box>
                    </Box>

                    {/* {isNotEmpty(name) && (
                        <Box
                            id="profileXS"
                            sx={{
                                display: {
                                    sm: "block",
                                    smd: "none",
                                    md: "none",
                                },
                            }}
                            style={{ margin: "5px 0" }}
                        >
                            {name}
                            {" " + t(`common.bracketLeft`)}
                            {interfaceUsername}
                            {t(`common.bracketRight`)}
                            {isNotEmpty(post) && `（${post}）`}
                        </Box>
                    )} */}
                </Box>
            </Box>

            {/* mobile */}
            {isMobile && (
                <Box className={grayClass} style={{ width: "100%" }}>
                    <Box className="mobileUserOrg">
                        {userOrg.length > 0 &&
                            isObjectNotEmpty(selectedUserOrg) && (
                                <Box id="userOrgXs">
                                    <FormControl id="userOrg-labelXs">
                                        <Select
                                            labelId="userOrg-label"
                                            id="userOrg-selectXs"
                                            value={selectedUserOrg}
                                            label={t("common.schoolName")}
                                            onChange={handleUserOrgChange}
                                            inputProps={{
                                                "aria-labelledby":
                                                    "userOrg-select",
                                            }}
                                        >
                                            {userOrg.length > 0 &&
                                                userOrg.map((item) => (
                                                    <MenuItem
                                                        value={item}
                                                        key={item.fullName}
                                                    >
                                                        {item.fullName}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            )}
                        <Box id="logoutBtnXs" onClick={handleLogout}>
                            {t(
                                `common.portal.${
                                    isEmpty(token) ? "login" : "logout"
                                }`
                            )}
                        </Box>
                    </Box>
                    {isNotEmpty(name) && (
                        <Box id="profileXs" style={{ margin: "5px 0" }}>
                            {selectedUserOrg?.type !== "E" && name}
                            {selectedUserOrg?.type !== "E" &&
                                " " + t(`common.bracketLeft`)}
                            {selectedUserOrg?.type !== "E" && interfaceUsername}
                            {selectedUserOrg?.type !== "E" &&
                                t(`common.bracketRight`)}
                            {isNotEmpty(post) &&
                                (selectedUserOrg?.type === "E"
                                    ? `${post}`
                                    : `（${post}）`)}
                        </Box>
                    )}
                </Box>
            )}
            {/* <Box
                sx={{ display: { xs: "inline-block", sm: "none" } }}
                style={{ width: "100%" }}
            >
                <Box id="logoutBtnXs" onClick={handleLogout}>
                    {t(`common.portal.${isEmpty(token) ? "login" : "logout"}`)}
                </Box>
                {userOrg.length > 0 && isObjectNotEmpty(selectedUserOrg) && (
                    <Box id="userOrgXs">
                        <FormControl id="userOrg-labelXs">
                            <Select
                                labelId="userOrg-label"
                                id="userOrg-selectXs"
                                value={selectedUserOrg}
                                label={t("common.schoolName")}
                                onChange={handleUserOrgChange}
                                inputProps={{
                                    "aria-labelledby": "userOrg-select",
                                }}
                            >
                                {userOrg.length > 0 &&
                                    userOrg.map((item) => (
                                        <MenuItem
                                            value={item}
                                            key={item.fullName}
                                        >
                                            {item.fullName}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Box>
                )}
                {isNotEmpty(name) && (
                    <Box id="profile">
                        {name}
                        {" " + t(`common.bracketLeft`)}
                        {interfaceUsername}
                        {t(`common.bracketRight`)}
                        {isNotEmpty(post) && `（${post}）`}
                    </Box>
                )}
            </Box> */}
            <Box
                className={`headerTitle ${grayClass}`}
                style={{ justifyContent: "space-between" }}
            >
                <Box className="deco"></Box>
                {/* <img src={transportIco} alt="" /> */}
                <Box>
                    <Typography
                        variant="h5"
                        component="h1"
                        style={{ whiteSpace: "pre-wrap" }}
                    >
                        {headerTitle
                            ? headerTitle
                            : // ? t(`${headerTitle}`)
                              t(`form.${formName}`)}
                    </Typography>
                </Box>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                    <IconButton
                        onClick={() =>
                            dispatch(updateMobileNavStatus(isMobileNavOpen))
                        }
                        style={{ marginRight: "5px" }}
                        aria-label="menu"
                    >
                        <MenuIcon />
                    </IconButton>
                </Box>
            </Box>
            {formId === "Form101" && (
                <Box style={{ marginBottom: "-10px", marginTop: "5px" }}>
                    {t(`Form101.label.timeoutNote`)}
                </Box>
            )}
            <Dialog
                open={openPopup}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={grayClass}
            >
                <DialogTitle id="alert-dialog-title">
                    {t("common.switchLang.title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <p>
                            {formId === "Form101"
                                ? t("Form101.label.switchLangContent")
                                : t("common.switchLang.content")}
                        </p>
                        <p>
                            {formId === "Form101"
                                ? t("Form101.label.switchLangContent2")
                                : t("common.switchLang.content2")}
                        </p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t("common.cancel")}</Button>
                    <Button onClick={handleConfirm}>
                        {t("common.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <PortalNavbar aside className="drawer" />
            </Box>

            <AlertDialog
                formOpen={errorOpen}
                content={t("common.emailupdate")}
                className={grayClass}
                confirmButton={{
                    action: () => {
                        setErrorOpen(false);
                        setOpen(true);
                    },
                    label: t("common.confirm"),
                }}
            />
        </Box>
    );
}
